import React, { useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { LoadingComponent } from "../../../../components/state/Loading";

import { FstyrSelect } from "../FstyrSelect";
import { ReplacementField } from "../../../../../core/entities/replacementField";
import { ReactComponent as FstyrLogo } from "../../../../../resources/logos/fstyr-logo.svg";

export function TinyMceEditor({
    setValue,
    value,
    replacementFields
}: {
    replacementFields: ReplacementField[];
    value: string;
    setValue: (value: string) => void;
}) {
    const editorRef = useRef<Editor>(null);

    const [hidden, setHidden] = useState<boolean>(true);
    const plugins = ["lists", "link", "image", "anchor", "table"];

    function pastReplacementField(value: string | null) {
        if (value) {
            editorRef.current?.editor?.insertContent(value);
        }
    }

    return (
        <>
            {hidden && (
                <div>
                    <LoadingComponent />
                </div>
            )}
            <div hidden={hidden} className={"space-y-12"}>
                {replacementFields && (
                    <FstyrSelect
                        options={replacementFields.map((x) => ({
                            label: x.displayName,
                            value: x.key
                        }))}
                        onChange={(value) => pastReplacementField(value)}
                        placeholder={"Tilføj flettefelt"}
                    />
                )}

                <div className={"relative"}>
                    <div className={"absolute z-10 right-[67.5px] top-[95px]"}>
                        <FstyrLogo width="190" height="auto" />
                    </div>
                    <Editor
                        tinymceScriptSrc={
                            process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
                        }
                        ref={editorRef}
                        initialValue={value}
                        onEditorChange={(s, e) => setValue(s)}
                        onInit={(s) => setHidden(false)}
                        init={{
                            // @ts-ignore
                            license_key: "gpl",
                            width: 1008,
                            height: 1442,
                            menubar: false,
                            plugins: plugins,
                            toolbar:
                                "undo redo | example styles fontsize | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist table | link",
                            link_assume_external_targets: true,
                            table_toolbar:
                                "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
                            content_style:
                                "body { font-family: Arial, Helvetica, sans-serif; padding-left:85px; padding-bottom:101.7px; padding-right:67.5px; padding-top:137.7px; margin: 0; } th, td {padding: 0 !important;}",
                            language: "da"
                        }}
                    />
                </div>
            </div>
        </>
    );
}
